var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactusPana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.15,
    y: 88.84,
    width: 173.59,
    height: 155.3,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.74,244.14s0-1,0-2.88,0-4.69,0-8.32c0-7.29-.06-17.95-.1-31.52-.05-27.14-.12-65.91-.2-112.58l.39.39L41.17,89.3h0l.46-.46c0,56.5,0,109.67,0,155.3l-.41-.4,125.55.2,35.42.11,9.37,0,2.42,0,.83,0s-.26,0-.79,0l-2.37,0-9.29.05-35.32.11-125.82.2h-.41v-.41c0-45.63,0-98.8-.05-155.3v-.46h.48l173.57.07h.4v.39c-.08,46.77-.15,85.63-.2,112.82,0,13.54-.08,24.17-.1,31.44,0,3.6,0,6.36,0,8.25S214.74,244.14,214.74,244.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71,116.43c0,.26-9.14.47-20.4.47s-20.41-.21-20.41-.47S76,116,87.31,116,107.71,116.18,107.71,116.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.26,128.1c0,.25-25.1.46-56,.46s-56.07-.21-56.07-.46,25.1-.47,56.07-.47S181.26,127.84,181.26,128.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.2,
    y: 147.85,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.2,
    y: 147.85,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.53,
    y: 147.52,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 147.85,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.21,
    y: 147.85,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.21,
    y: 147.85,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.21,
    y: 147.85,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.2,
    y: 163.4,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.2,
    y: 163.4,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.2,
    y: 163.4,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 163.4,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.21,
    y: 163.4,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.54,
    y: 163.06,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.21,
    y: 163.4,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.2,
    y: 178.94,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.53,
    y: 178.61,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.2,
    y: 178.94,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 178.94,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.21,
    y: 178.94,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.21,
    y: 178.94,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.21,
    y: 178.94,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.2,
    y: 194.49,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.2,
    y: 194.49,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.2,
    y: 194.49,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.54,
    y: 194.16,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.21,
    y: 194.49,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.21,
    y: 194.49,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.21,
    y: 194.49,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.2,
    y: 210.04,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.2,
    y: 210.04,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.2,
    y: 210.04,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 210.04,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.21,
    y: 210.04,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.54,
    y: 209.71,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.21,
    y: 210.04,
    width: 7.31,
    height: 7.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.75,
    y: 51.92,
    width: 11.16,
    height: 55.51,
    transform: "translate(-0.42 2.17) rotate(-0.31)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.04,
    y: 52.11,
    width: 28.89,
    height: 30.64,
    transform: "translate(-0.36 1.7) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.8,
    y: 51.95,
    width: 28.89,
    height: 30.64,
    transform: "translate(-0.36 1.85) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,60.65q28.8.24,57.64-.27a.31.31,0,0,0,0-.61c-19.19-.11-38.44,0-57.63.35a.27.27,0,0,0,0,.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.02,
    y: 82.3,
    width: 52.49,
    height: 24.97,
    transform: "translate(-0.5 1.67) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.26,
    y: 82.02,
    width: 52.49,
    height: 24.97,
    transform: "translate(-0.5 1.95) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,89.39c34.87.4,69.86,0,104.72-.52a.31.31,0,0,0,0-.61c-34.87-.18-69.86-.16-104.72.6a.27.27,0,0,0,0,.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.36,
    y: 107.42,
    width: 203.35,
    height: 8.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.65,
    y: 111.72,
    width: 8.25,
    height: 30.53,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.88,
    y: 111.72,
    width: 8.26,
    height: 30.53,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.7,
    y: 31.22,
    width: 11.16,
    height: 76.34,
    transform: "translate(-0.37 2.23) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.91,
    y: 45.44,
    width: 17.33,
    height: 61.87,
    transform: "matrix(1, -0.01, 0.01, 1, -0.4, 2.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,57.32a64,64,0,0,1-8.67.3,63.88,63.88,0,0,1-8.66-.3c0-.17,3.88-.3,8.66-.3S439,57.15,439,57.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,54.72a64,64,0,0,1-8.67.3,63.88,63.88,0,0,1-8.66-.3c0-.17,3.88-.3,8.66-.3S439,54.55,439,54.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,98a125.29,125.29,0,0,1-17.33,0c0-.17,3.88-.3,8.66-.3S439,97.79,439,98Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,95.36a125.29,125.29,0,0,1-17.33,0c0-.17,3.88-.3,8.66-.3S439,95.19,439,95.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.57,89.69c-.16,0-.3-6.24-.3-13.94s.14-13.94.3-13.94.3,6.24.3,13.94S430.74,89.69,430.57,89.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.15,
    y: 60.59,
    width: 18.87,
    height: 46.7,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.11,44.22a3.21,3.21,0,1,1-3.2-3.21A3.21,3.21,0,0,1,419.11,44.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.91,
    y: 53.04,
    width: 1.98,
    height: 45.42,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.26,342.83c5.24-2.7,11.4-3.05,17.21-2.09,3.12.52,6.37,1.45,8.5,3.8s2.52,6.47.08,8.48c-1.45,1.2-3.47,1.38-5.35,1.36-4.55-.05-9.6-.85-13.23,1.88-2.08,1.57-3.46,4.16-5.93,4.93s-5.17-.68-6.45-2.87a10,10,0,0,1-.73-7.39A11.28,11.28,0,0,1,74.26,342.83Z",
    style: {
      fill: "#EF476F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.27,319.69c3.2,4.57,9.42,3.05,12.31.27s4.1-6.84,5.21-10.69c2.53-8.81,5.09-18,3.2-27a14.93,14.93,0,0,0-3.45-7.34,7.84,7.84,0,0,0-7.43-2.48c-3.14.83-5.08,3.9-6.49,6.83a64.33,64.33,0,0,0-6.37,27.64c0,4.45.51,9.12,3,12.8",
    style: {
      fill: "#EF476F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.48,326.25c3.48-4.13,4.14-10.14,2.59-15.31s-5-9.56-9.06-13.15a48.81,48.81,0,0,0-16.23-9.57,17.2,17.2,0,0,0-7.3-1.24,7.66,7.66,0,0,0-6.13,3.7c-1.71,3.26-.07,7.21,1.7,10.44a123.66,123.66,0,0,0,10.66,16.23c3.2,4.12,6.86,8.18,11.73,10S51.37,329,54,325.66",
    style: {
      fill: "#EF476F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.06,388.63a10.36,10.36,0,0,0,.29-2.07c.14-1.52.33-3.41.55-5.67a81.17,81.17,0,0,1,1.27-8.32,65.1,65.1,0,0,1,3-9.81,36.33,36.33,0,0,1,5-8.88,18.63,18.63,0,0,1,6.34-5.26A17.67,17.67,0,0,1,83.87,347a10.14,10.14,0,0,0,2.07-.3,9.45,9.45,0,0,0-2.1,0,16.31,16.31,0,0,0-5.57,1.44,18.74,18.74,0,0,0-6.68,5.31,35.56,35.56,0,0,0-5.19,9.06,60,60,0,0,0-3,10,70.8,70.8,0,0,0-1.11,8.42c-.18,2.41-.24,4.36-.28,5.71A9.23,9.23,0,0,0,62.06,388.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.45,384.27a4.45,4.45,0,0,0,0-1v-2.76c0-2.39,0-5.85.12-10.12.21-8.55,1-17.75,2.37-30.72,1.34-12.19,3.15-26.39,5.06-35.61.4-2.1.82-4,1.2-5.64s.69-3.09,1-4.25.48-2,.65-2.67a4,4,0,0,0,.17-1,3.58,3.58,0,0,0-.34.9c-.21.69-.47,1.57-.8,2.64s-.72,2.56-1.13,4.22-.89,3.53-1.34,5.62a315.74,315.74,0,0,0-5.32,33c-1.42,13-2.06,24.83-2.12,33.39,0,4.29,0,7.76.15,10.15.07,1.12.13,2,.17,2.75A4.1,4.1,0,0,0,62.45,384.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5,361.45a18.15,18.15,0,0,0,0-2.88,78.38,78.38,0,0,0-.88-7.8,102.25,102.25,0,0,0-2.53-11.36A92.88,92.88,0,0,0,54.31,326a71.64,71.64,0,0,0-14-21.73,36.68,36.68,0,0,0-3.28-3.05c-.51-.42-.95-.85-1.41-1.18l-1.27-.88A18,18,0,0,0,32,297.57c-.14.18,3.43,2.29,7.94,7.08A75.57,75.57,0,0,1,53.53,326.3a107.1,107.1,0,0,1,4.78,13.32c1.24,4.18,2.07,8,2.69,11.25s.94,5.89,1.15,7.73A20.42,20.42,0,0,0,62.5,361.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.45 401.71 42.73 433.04 82.98 433.04 85.27 401.71 40.45 401.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.56,
    y: 389.36,
    width: 53.51,
    height: 12.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.56 431.84 36.56 435.26 39.07 435.26 89.19 435.26 89.19 431.84 36.56 431.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.54 441.29 39.07 435.26 87.27 435.26 84.39 441.29 41.54 441.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.52,412a1.22,1.22,0,0,1-.19.28c-.16.22-.35.48-.6.8l-2.34,3-.11.14-.1-.14-5.76-8h.33l-5.67,8-.18.25-.2-.23-6.72-8h.39c-.12.14-.25.3-.37.46l-6,7.54-.2.25-.18-.26-5.68-8,.33,0c-2.79,3.19-5.17,5.89-7,8l-.12.14-.09-.16c-.93-1.54-1.66-2.78-2.19-3.67-.23-.4-.42-.72-.56-1a1.41,1.41,0,0,1-.18-.35s.09.1.24.31l.62.94,2.3,3.61-.22,0,6.87-8.06.18-.2.15.22,5.73,8H56.6l6-7.55.37-.46.2-.24.19.23c2.36,2.81,4.62,5.52,6.71,8h-.38l5.73-8,.17-.23.16.23,5.64,8.06h-.2L83.63,413l.65-.76Q84.51,411.93,84.52,412Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.83,401.5c0,.14-10.09.25-22.52.25s-22.53-.11-22.53-.25,10.08-.25,22.53-.25S85.83,401.36,85.83,401.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.86,435.6c0,.14-11,.25-24.48.25s-24.48-.11-24.48-.25,11-.25,24.48-.25S87.86,435.46,87.86,435.6Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.1,309.11h93.53a15.13,15.13,0,0,1,15.13,15.13V441.86a0,0,0,0,1,0,0H348a0,0,0,0,1,0,0V324.24A15.13,15.13,0,0,1,363.1,309.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.34,309.79c.15,0,.26,29.55.26,66s-.11,66-.26,66-.26-29.55-.26-66S461.2,309.79,461.34,309.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.36,165a105.06,105.06,0,0,1,18.82,55.34c.58,13.3-1.21,27.47,5.1,39.19,9.06,16.82,28.65,16.25,34.65,34.38,2.61,7.89-2.2,25.24-3.5,33.45-1.47,9.32,4.23,17.15,2.76,26.48-1.35,8.55-7.75,14.65-15.43,18.63-6.84,3.54-13.16,3.64-20.27.69-13.56-5.61-24.84-11.53-34.49-22.57-13.56-15.5-17.66-37-20-57.43a503.87,503.87,0,0,1,3.07-135.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.35,375.07a3.59,3.59,0,0,1,.43-.11c.29-.07.73-.14,1.29-.31a22,22,0,0,0,10.86-6.83,12.81,12.81,0,0,0,2.42-4.29,23.54,23.54,0,0,0,.85-5.49,54.09,54.09,0,0,0-1.3-12.74c-.87-4.54-2-9.38-2.34-14.63a30.3,30.3,0,0,1,.57-8,51.29,51.29,0,0,1,2.54-8,85.74,85.74,0,0,0,2.86-8.13,20.74,20.74,0,0,0,.7-8.7,19.67,19.67,0,0,0-3.25-8.08,37.08,37.08,0,0,0-5.67-6.42c-4.13-3.86-8.6-7-12.42-10.62a70.35,70.35,0,0,1-16.18-22.34,68.47,68.47,0,0,1-3.72-10c-.48-1.49-.76-2.93-1.1-4.23s-.49-2.52-.71-3.6c-.31-2.19-.55-3.88-.61-5,0-.56-.08-1-.1-1.32s0-.45,0-.45,0,.15.07.45.09.75.16,1.31c.09,1.15.36,2.84.7,5,.23,1.08.48,2.28.75,3.59s.64,2.71,1.14,4.2a69.73,69.73,0,0,0,3.77,9.9,70.68,70.68,0,0,0,16.17,22.14c3.8,3.54,8.28,6.71,12.45,10.59a37.85,37.85,0,0,1,5.75,6.51,20.16,20.16,0,0,1,3.33,8.3,21.2,21.2,0,0,1-.71,8.91c-.78,2.84-1.87,5.53-2.88,8.17a52.13,52.13,0,0,0-2.54,7.9,29.77,29.77,0,0,0-.57,7.89c.27,5.18,1.43,10,2.29,14.57a54.48,54.48,0,0,1,1.24,12.84,24.56,24.56,0,0,1-.9,5.58,13.53,13.53,0,0,1-2.51,4.37,20.72,20.72,0,0,1-6.32,4.95,20.24,20.24,0,0,1-4.75,1.8A11.69,11.69,0,0,1,429.35,375.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.16,410.8l48-22.79s18.69-90.75,22.23-97.56,18.3-12.7,18.3-12.7l-2.47,122.88L324.82,429l-67.68,6.41Z",
    style: {
      fill: "#EF476F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.21,432.3c-.27,0-1.6.82-.49,2.93s9.25,9.08,11.64,6.65-1.26-5.39-1.26-5.39Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.44,436.58s9.82,1.24,13.59,2.68c4.11,1.56,9.11.49,12.47-1.78a35.49,35.49,0,0,0,5.32-4.34l12.52-.2a15,15,0,0,0,2.44-15.51,16.83,16.83,0,0,0-2.86-4.89c-1.49-1.61-3.84-2.91-7.9-3.61l-14.87,3.21s-23-1.65-27.14.29c0,0-5.15,3.05-6.74,4.33-.6.49-2.43,6.35,1.32,9.4,0,0-3.26,2.59-1.49,4.92l.84,1s-2.19,2.84-1.06,4.08,11,7,14.51,5.64.61-4.65-.95-5.25",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.06,421.09a10.83,10.83,0,0,1,1.22.44c.77.29,1.9.71,3.32,1.16.7.23,1.48.46,2.33.68s1.76.41,2.71.72a5.79,5.79,0,0,1,2.7,1.63,3.31,3.31,0,0,1,.72,3.29,2.58,2.58,0,0,1-1.21,1.31,4.7,4.7,0,0,1-1.64.46,13.87,13.87,0,0,1-3.13-.17,28,28,0,0,1-5.08-1.32c-1.41-.5-2.52-1-3.29-1.3a6.53,6.53,0,0,1-1.17-.56,10.54,10.54,0,0,1,1.23.41c.78.28,1.91.71,3.32,1.17a30,30,0,0,0,5,1.23,13.82,13.82,0,0,0,3,.14,4.19,4.19,0,0,0,1.49-.42,2.16,2.16,0,0,0,1-1.1A2.93,2.93,0,0,0,215,426a5.47,5.47,0,0,0-2.51-1.53c-.92-.31-1.84-.51-2.68-.75s-1.63-.49-2.33-.73c-1.42-.49-2.53-1-3.29-1.29A6.83,6.83,0,0,1,203.06,421.09Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.94,414a8.43,8.43,0,0,1,1.21.44c.78.3,1.9.73,3.3,1.19s3.09,1,5,1.43a6.9,6.9,0,0,1,2.91,1.18,2.43,2.43,0,0,1,.85,1.51,3.11,3.11,0,0,1-.25,1.75,4.19,4.19,0,0,1-2.57,2.18,6.75,6.75,0,0,1-3.13.25,30.08,30.08,0,0,1-5-1.46l-3.31-1.16a9.24,9.24,0,0,1-1.2-.47,7.63,7.63,0,0,1,1.25.32l3.35,1a34,34,0,0,0,5,1.36,6.49,6.49,0,0,0,2.95-.26,3.83,3.83,0,0,0,2.33-2,2.33,2.33,0,0,0-.49-2.79,6.65,6.65,0,0,0-2.74-1.11c-1.91-.48-3.6-1-5-1.52s-2.5-1-3.26-1.32A8.06,8.06,0,0,1,203.94,414Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.67,416a12.45,12.45,0,0,1-.45-2,11,11,0,0,1-.49-2,3.53,3.53,0,0,1,.89,1.87A3.32,3.32,0,0,1,208.67,416Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.3,416.32,234.55,413s-24.29-11.34-24.7-10.72-1.73.54-1.44,3.5,14.44,8.94,14.89,10-.3,6.22,4.93,9.93,9,3.8,9,3.8",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.23,429.42H237l-.6-.06a14.55,14.55,0,0,1-2.27-.55,22.21,22.21,0,0,1-7.42-4.27,10.46,10.46,0,0,1-3-5.11,23.22,23.22,0,0,1-.52-3.27,1.82,1.82,0,0,0-.09-.37.72.72,0,0,0-.23-.24,7.92,7.92,0,0,0-.71-.46c-.49-.29-1-.57-1.54-.85-2.1-1.13-4.35-2.26-6.61-3.56a39.45,39.45,0,0,1-3.37-2.13,12.28,12.28,0,0,1-1.58-1.32,4,4,0,0,1-.67-.84,1.64,1.64,0,0,1-.2-.55,2.47,2.47,0,0,1,0-.54,3.83,3.83,0,0,1,.37-2.11,2.57,2.57,0,0,1,.77-.77,1.71,1.71,0,0,0,.34-.29s0,0,.08-.09a.25.25,0,0,1,.17-.05.76.76,0,0,1,.17,0l.27.07c1.31.4,2.52.93,3.73,1.43,2.4,1,4.69,2,6.87,3,4.37,2,8.27,3.78,11.55,5.32.82.37,1.59.76,2.33,1.08l2.14.84,3.43,1.36,2.16.87.55.24c.13,0,.19.08.19.09s-.07,0-.2-.06l-.57-.19-2.19-.81L236.89,414l-2.16-.81c-.76-.31-1.53-.69-2.35-1.06l-11.58-5.23c-2.19-1-4.48-2-6.88-3-1.2-.49-2.42-1-3.68-1.41l-.22-.05s-.08,0-.08,0,0,0,0,0,0-.06,0-.1l0,0c.28.18.07.06.13.1l0,0a1.83,1.83,0,0,1-.42.38,2.05,2.05,0,0,0-.66.65,3.48,3.48,0,0,0-.32,1.89,1.87,1.87,0,0,0,.21.9,3.85,3.85,0,0,0,.6.76,11.72,11.72,0,0,0,1.53,1.27c1.08.78,2.21,1.46,3.33,2.11,2.25,1.3,4.48,2.44,6.59,3.57.53.29,1,.57,1.55.88a8.63,8.63,0,0,1,.75.48,1,1,0,0,1,.34.39,2,2,0,0,1,.1.45,25.93,25.93,0,0,0,.49,3.24,10.28,10.28,0,0,0,2.86,5,22.74,22.74,0,0,0,7.27,4.33,16.07,16.07,0,0,0,2.23.61c.26.06.46.08.6.1Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.44,430.56a3,3,0,0,1,.93.27,9.41,9.41,0,0,1,2.29,1.32,8.39,8.39,0,0,1,1.32,1.29,2.73,2.73,0,0,1,.71,2,2.26,2.26,0,0,1-1.62,1.75,4.32,4.32,0,0,1-2.54-.08,46.55,46.55,0,0,1-8.06-3.23,24.15,24.15,0,0,1-2.26-1.34,3.86,3.86,0,0,1-.77-.58,4.72,4.72,0,0,1,.85.44c.54.31,1.32.74,2.31,1.22a56.46,56.46,0,0,0,8,3.1,4,4,0,0,0,2.32.09,1.9,1.9,0,0,0,1.37-1.42,2.45,2.45,0,0,0-.6-1.78,8.33,8.33,0,0,0-1.24-1.27A13.89,13.89,0,0,0,210.44,430.56Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M324.48,429c-7.86-26.51-14.79-60.65-22.65-87.16-2.88,24.47.72,56.78,5.22,81,.53,2.84.77,5.62,3,7.49L324.48,429"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M311.61,410.8c-.11,0-.44-1.73-1.51-4.38a31.09,31.09,0,0,0-2.25-4.46,33.83,33.83,0,0,0-3.7-4.86,32.94,32.94,0,0,0-4.58-4.05,29.8,29.8,0,0,0-4.28-2.58c-2.56-1.26-4.28-1.72-4.25-1.82a5.38,5.38,0,0,1,1.22.29,10.15,10.15,0,0,1,1.39.46,18.21,18.21,0,0,1,1.8.74,28,28,0,0,1,4.4,2.52,32,32,0,0,1,4.69,4.08,32.35,32.35,0,0,1,3.72,5,28.6,28.6,0,0,1,2.19,4.57c.27.67.43,1.3.6,1.85a10.28,10.28,0,0,1,.36,1.43A6.39,6.39,0,0,1,311.61,410.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.59,276.51S301.46,332.66,301.46,343s18.83,81.93,18.83,81.93c-.18,2.85-.91,17.12-.91,17.12l105.59.37h0l1.61-22.7-8.24-21.63,8.23-61.15s5.54-35.5,6-45.43c.62-12.42-41.46-26.82-40.31-28.54L385,253.21,343.39,287l-8.23-23.76-9.86,9.31Z",
    style: {
      fill: "#EF476F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.74,291.45C384.31,310.78,363.4,346,363.4,346l-37.48,42.74s-2.45,21.71,2.45,28.37,13.31,11.21,13.31,11.21,9.89,0,22.46-10.51,47.24-53.94,47.24-53.94l11.91-14.37s14.2-34.88,11.55-52.63c-1-6.85-3.94-9.69-7.82-12.83C417.25,276.17,402.13,280.64,395.74,291.45Z",
    style: {
      fill: "#EF476F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.7,337.4a3.09,3.09,0,0,1-.18.4c-.13.28-.32.65-.55,1.14-.5,1-1.26,2.45-2.3,4.29-2.07,3.69-5.29,8.9-9.49,15.19-2.11,3.14-4.46,6.55-7.05,10.17s-5.53,7.35-7.95,11.71-4.62,9.12-7.27,13.88a87.68,87.68,0,0,1-9.53,13.91,55.74,55.74,0,0,1-12.62,11.16,39.74,39.74,0,0,1-14.62,5.66,32.77,32.77,0,0,1-14.16-.6,26.83,26.83,0,0,1-6-2.43,27.39,27.39,0,0,1-4.94-3.34,22.41,22.41,0,0,1-3.72-3.93,22.1,22.1,0,0,1-2.46-4.16,26.32,26.32,0,0,1-2-7.44,34.38,34.38,0,0,1-.17-4.87c0-.54.06-1,.08-1.27a3,3,0,0,1,0-.43,2.85,2.85,0,0,1,0,.43c0,.31,0,.73,0,1.27a37,37,0,0,0,.26,4.84,26.58,26.58,0,0,0,2.08,7.35,22.35,22.35,0,0,0,2.46,4.08,21.91,21.91,0,0,0,3.7,3.85,27.06,27.06,0,0,0,4.89,3.27,26.74,26.74,0,0,0,5.91,2.37,32.55,32.55,0,0,0,14,.54,39.34,39.34,0,0,0,14.42-5.62A55.45,55.45,0,0,0,383,407.75a86.77,86.77,0,0,0,9.47-13.82c2.65-4.73,4.79-9.53,7.3-13.87a130.12,130.12,0,0,1,8-11.73c2.6-3.6,5-7,7.09-10.12,4.24-6.25,7.5-11.43,9.62-15.08,1.07-1.83,1.86-3.26,2.38-4.24l.61-1.12A1.93,1.93,0,0,1,427.7,337.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,386.83c0,.07-.53.4-1.22,1.17a6,6,0,0,0-.68,7.36c.53.88,1,1.31,1,1.37s-.63-.28-1.29-1.16a5.9,5.9,0,0,1,.73-7.83A3,3,0,0,1,324,386.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.93,398.17a3,3,0,0,1,.59.14l.7.19,1,.18a13.93,13.93,0,0,0,6.18-.58,22.63,22.63,0,0,0,8-4.68,60.24,60.24,0,0,0,7.45-8.65,52.29,52.29,0,0,1,7.69-8.59c1.36-1.14,2.69-2.15,3.8-3.24a10.65,10.65,0,0,0,2.5-3.45,6.29,6.29,0,0,0-.57-5.9,4.64,4.64,0,0,0-1.81-1.35,3.07,3.07,0,0,1,.58.17,3.83,3.83,0,0,1,1.39,1.06,6.46,6.46,0,0,1,.76,6.16,11.12,11.12,0,0,1-2.54,3.62c-1.13,1.12-2.47,2.16-3.8,3.3a53.4,53.4,0,0,0-7.58,8.54,59.05,59.05,0,0,1-7.56,8.7,22.63,22.63,0,0,1-8.16,4.66,13.59,13.59,0,0,1-6.33.43l-1-.23c-.28-.08-.51-.18-.69-.24A2.71,2.71,0,0,1,330.93,398.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.83,285.51a5.42,5.42,0,0,1-.42.6c-.33.42-.75,1-1.28,1.67-1.14,1.42-2.71,3.54-4.63,6.18a202.28,202.28,0,0,0-13.33,21.67c-4.72,8.76-8.62,16.89-11.61,22.69-1.48,2.91-2.7,5.25-3.59,6.85L365,347a3.67,3.67,0,0,1-.39.62,3.88,3.88,0,0,1,.29-.67l.94-1.89,3.43-6.91c2.9-5.85,6.76-14,11.48-22.78a182,182,0,0,1,13.5-21.64c2-2.61,3.57-4.71,4.76-6.09l1.36-1.61A3.18,3.18,0,0,1,400.83,285.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.8,396.44c4.87,2.64,10.23,2.36,15.67,1.3a24.32,24.32,0,0,0,14-8.38A24.29,24.29,0,0,1,346,402.14c-3.46,3.39-8.48,5.35-13.24,4.48s-9.58-5.35-10-10.18"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M368.9,367.58a21.49,21.49,0,0,1,3,16.12c4.13-6.32,5.1-14.32,4-21.79s-4.15-14.52-7.53-21.27c0,0-3.72,6.3-3.76,7-.18,3.64,1.16,10.48,1.86,14.05a7.81,7.81,0,0,1,2.27,7.06"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.32,422.6c9.94,7.75,24.69,8.11,35.56,1.75,10.47-6.13,16.92-17.17,22.9-27.72,9.27-16.34,20.57-36.55,27.19-54.13,0,0-18.55,25.31-24.14,36.22A180.05,180.05,0,0,1,388.17,400a54.56,54.56,0,0,1-47.88,23.33"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M319.38,442a1,1,0,0,1,0-.31c0-.24,0-.54,0-.91,0-.85.07-2,.13-3.47.14-3,.33-7.3.57-12.43V425c-1.79-6-3.89-13.28-6.07-21.14-2.88-10.42-5.31-19.9-6.95-26.79-.81-3.44-1.45-6.24-1.85-8.18-.19-.93-.34-1.68-.45-2.23a6.68,6.68,0,0,1-.13-.79,4.09,4.09,0,0,1,.23.76l.55,2.22c.49,2,1.17,4.74,2,8.13,1.73,6.87,4.22,16.33,7.1,26.74,2.17,7.86,4.24,15.14,6,21.15v.07c-.31,5.13-.57,9.4-.76,12.44-.1,1.45-.18,2.61-.24,3.46,0,.36-.06.66-.08.9A1.05,1.05,0,0,1,319.38,442Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,283.46c0,.08-1.08-.3-2.81-.73a33.9,33.9,0,0,0-6.89-1,33.18,33.18,0,0,0-6.94.54c-1.76.33-2.83.63-2.85.55a2.58,2.58,0,0,1,.72-.32,20.62,20.62,0,0,1,2.05-.59,27.22,27.22,0,0,1,7-.7,27.63,27.63,0,0,1,7,1.12,17,17,0,0,1,2,.72C424.78,283.3,425,283.42,425,283.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.57,265a2.94,2.94,0,0,1-.27.52l-.85,1.43c-.75,1.24-1.86,3-3.27,5.19-2.83,4.33-6.88,10.24-11.67,16.52-3.85,5.07-7.58,9.62-10.63,13.18l-.22.25-.13-.3c-1.46-3.18-2.66-5.82-3.53-7.73-.39-.88-.7-1.6-.95-2.15a4,4,0,0,1-.29-.77,4.1,4.1,0,0,1,.41.72c.27.54.61,1.24,1.05,2.1.91,1.89,2.17,4.5,3.68,7.66l-.34-.05c3-3.6,6.69-8.16,10.54-13.22,4.78-6.28,8.86-12.14,11.77-16.42l3.41-5.09.93-1.38A2.21,2.21,0,0,1,391.57,265Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.88,426.27c-.15,0,.31-5.21,1-11.6s1.4-11.55,1.54-11.53-.32,5.2-1,11.59S416,426.28,415.88,426.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.5,424.9a74.48,74.48,0,0,1,1.19,8.72,70.84,70.84,0,0,1,.67,8.77,77.12,77.12,0,0,1-1.19-8.72A75.84,75.84,0,0,1,343.5,424.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.91,310.69a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.48,285.27a1.28,1.28,0,0,0-1.94-.77l-.06.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.55,305.74a1.28,1.28,0,0,0-1.94-.77l-.06,0a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.68,295.46a1.27,1.27,0,0,0-1.93-.77l-.07.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.11,285.33a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.22,1.22,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.1,273.63a1.28,1.28,0,0,0-1.94-.77l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.77,289.73a1.28,1.28,0,0,0-1.94-.77l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,294.37a1.27,1.27,0,0,0-1.93-.77l-.07.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.86,315.24a1.28,1.28,0,0,0-1.94-.77l-.07,0a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.14,375.26a1.28,1.28,0,0,0-1.94-.77l-.06.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.32,340.64a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,279.86a1.28,1.28,0,0,0-1.94-.77l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.24,348.78a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.22,1.22,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.81,289.47a1.27,1.27,0,0,0-1.93-.77l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.88,328.31a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.22,1.22,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.67,356.36a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.86,333a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.22,1.22,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.87,289.67a1.27,1.27,0,0,0-1.93-.77l-.07.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,267.05a1.27,1.27,0,0,0-1.93-.77l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.13,303.52a1.27,1.27,0,0,0-1.94-.77l-.06.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.89,414.77A1.27,1.27,0,0,0,351,414l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.34,396.47a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.21,405.44a1.28,1.28,0,0,0-1.94-.77l-.06.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.31,420.89a1.28,1.28,0,0,0-1.94-.77l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.74,426.06a1.28,1.28,0,0,0-1.94-.77l-.06.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.24,391.46a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.22,1.22,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.44,400.26a1.27,1.27,0,0,0-1.94-.77l-.06.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.61,391.41a1.26,1.26,0,0,0-1.93-.77l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.72,435.38a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.29,410.9a1.27,1.27,0,0,0-1.93-.77l-.07.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.92,430.81A1.28,1.28,0,0,0,395,430l-.06.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.57,326.55a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.9,377.38a1.28,1.28,0,0,0-1.94-.77l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.36,396.63a1.28,1.28,0,0,0-1.94-.77l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.43,412.09a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.62,434.42a1.27,1.27,0,0,0-1.94-.77l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.62,428.57a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.22,1.22,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,418.06a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.22,1.22,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,406.63a1.27,1.27,0,0,0-1.94-.77l-.06.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.2,370.33a1.28,1.28,0,0,0-1.94-.77l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.32,315.24a1.28,1.28,0,0,0-1.94-.77l-.07,0a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.6,363a1.28,1.28,0,0,0-1.94-.77l-.06.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92,347.43a1.28,1.28,0,0,0-1.94-.77l-.06,0a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.89,396.41a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.22,1.22,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.94,386.8A1.27,1.27,0,0,0,339,386l-.07.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.19,334.05a1.27,1.27,0,0,0-1.93-.77l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.74,371.4a1.28,1.28,0,0,0-1.94-.77l-.06.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,354.26a1.28,1.28,0,0,0-1.94-.77l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.19,309.5a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,275.61a1.28,1.28,0,0,0-1.94-.77l-.07.06a1.21,1.21,0,1,0,2,.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.94,279.86a1.28,1.28,0,0,0-1.94-.77l-.07.05a1.21,1.21,0,1,0,2,.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.05,158.21c-7.87,5-11,15.51-9.52,21.72.76,3.13,2.18,6.28,1.56,9.43-.53,2.73-2.5,4.92-4,7.28a21.92,21.92,0,0,0,27.4,31.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.39,199.2c-19.16-42.14,26.42-63.31,51.28-56.29,23.37,6.6,33.34,18.23,37.19,33.86s3.66,32.58-2.47,47.47c-3,7.34-8.46,14.8-16.35,15.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.84,302.11c-.33-20.14-.57-47.79-.57-47.68S319,251.56,315.37,229c-1.78-11.23-1.21-29.64-.27-44.69.86-13.55,9.83-30.17,23.33-28.74l42.15,10.65a7.93,7.93,0,0,1,7.1,8.06h0l-2.74,87.17",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.64,198.08a2.87,2.87,0,0,0,2.74,2.93,2.75,2.75,0,0,0,3-2.56,2.89,2.89,0,0,0-2.74-2.94A2.76,2.76,0,0,0,322.64,198.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.56,198.08A2.87,2.87,0,0,0,355.3,201a2.75,2.75,0,0,0,3-2.56,2.87,2.87,0,0,0-2.74-2.93A2.75,2.75,0,0,0,352.56,198.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.52,192.82c.35.39,2.6-1.16,5.71-1s5.34,1.74,5.7,1.37c.17-.16-.18-.85-1.15-1.61a7.9,7.9,0,0,0-4.54-1.57,7.66,7.66,0,0,0-4.56,1.31C319.7,192,319.35,192.64,319.52,192.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.1,193.56c.36.38,2.55-1.26,5.66-1.26s5.41,1.54,5.74,1.16c.17-.17-.2-.85-1.2-1.57a7.9,7.9,0,0,0-4.6-1.4,7.58,7.58,0,0,0-4.5,1.48C349.24,192.71,348.92,193.39,349.1,193.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.42,217.56c0-.18-1.92-.51-5.06-.92-.8-.08-1.55-.24-1.68-.78a4,4,0,0,1,.53-2.36c.74-1.92,1.53-3.94,2.35-6.06,3.27-8.62,5.63-15.72,5.28-15.85s-3.28,6.76-6.54,15.39l-2.26,6.1a4.58,4.58,0,0,0-.41,3.12,2,2,0,0,0,1.31,1.16,5.08,5.08,0,0,0,1.35.19C336.45,217.72,338.41,217.73,338.42,217.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.27,254.43a57.47,57.47,0,0,0,30.24-8.06s-7.64,15.7-30.24,13.59Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.33,189.13c.3.85,3.42.44,7.07.89s6.61,1.43,7.1.67c.22-.36-.3-1.16-1.49-2a12.41,12.41,0,0,0-10.8-1.19C348.87,188.06,348.19,188.73,348.33,189.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.24,185c.55.71,2.7,0,5.28-.06s4.77.48,5.27-.26c.22-.36-.12-1.07-1.08-1.74a7.3,7.3,0,0,0-4.29-1.16,7.38,7.38,0,0,0-4.21,1.42C320.3,183.91,320,184.64,320.24,185Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.81,204c.33-.16,12.09-5.36,12.23,8.16s-13.47,10.87-13.5,10.48S383.81,204,383.81,204Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.62,217.46c.06,0,.24.16.64.34a2.38,2.38,0,0,0,1.76,0c1.42-.54,2.6-2.82,2.64-5.26a7.57,7.57,0,0,0-.69-3.36,2.7,2.7,0,0,0-1.79-1.79,1.19,1.19,0,0,0-1.38.66c-.18.38-.09.65-.16.67s-.3-.22-.19-.78a1.49,1.49,0,0,1,.52-.85,1.76,1.76,0,0,1,1.3-.36,3.31,3.31,0,0,1,2.48,2.07,8,8,0,0,1,.86,3.76c-.06,2.72-1.43,5.29-3.38,5.87a2.54,2.54,0,0,1-2.16-.33C386.65,217.79,386.58,217.48,386.62,217.46Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.93,148.88c-7.52,3.89-10.62,19.27-7.51,27.15s11.5,11.72,19.77,13.53,16.38,2,24.54-.24c.56,5.48,3.85,11.11,9.17,12.56,7.05,1.91,14.15-4.54,15.72-11.67s-.79-14.47-3.11-21.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.58,197.93s-.34.4-1.05,1a35.32,35.32,0,0,1-3.11,2.35,19.24,19.24,0,0,1-5.26,2.55,11.37,11.37,0,0,1-7.17-.11,11.09,11.09,0,0,1-5.43-4.69,15.07,15.07,0,0,1-1.95-5.52,20.14,20.14,0,0,1-.21-3.92,4.37,4.37,0,0,1,.17-1.42c.15,0,0,2.05.58,5.24a15.52,15.52,0,0,0,2,5.24,10.67,10.67,0,0,0,5.09,4.34,10.94,10.94,0,0,0,6.71.14,20.22,20.22,0,0,0,5.15-2.31C391.88,199.08,393.5,197.82,393.58,197.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.34,226.24a12.78,12.78,0,0,0,1.68,3.29,4.36,4.36,0,0,0,3.11,1.81,4,4,0,0,0,3.32-1.81,6.31,6.31,0,0,0,.92-3.78c-.05-1.19-.6-2.61-1.78-2.75a2.9,2.9,0,0,0-1.43.32l-6.22,2.52",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.82,231.35c0-.19,1.4.36,3.32-.41a4.72,4.72,0,0,0,2.51-2.27,5,5,0,0,0,.08-4.07,4.71,4.71,0,0,0-.54-.93c-.25-.26-.21-.25-.47-.21s-.67.26-1,.39l-1,.42c-1.33.54-2.54,1-3.55,1.39-2,.76-3.33,1.16-3.39,1s1.12-.8,3.08-1.74c1-.47,2.15-1,3.46-1.61l1-.45c.37-.15.64-.31,1.14-.47a1.46,1.46,0,0,1,.92,0,1.7,1.7,0,0,1,.69.54,5.69,5.69,0,0,1,.51,6.15,5.27,5.27,0,0,1-3.16,2.55,4.93,4.93,0,0,1-2.69.11C342.09,231.63,341.8,231.42,341.82,231.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,194.73c-1.38-.1-12.55,1.35-11.67,22.1.82,19.39,14.42,15.12,18.76,7.82C410.17,217.74,412.55,195.68,399,194.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.87,197.18a3.37,3.37,0,0,1-.05-.54c0-.41,0-.93-.06-1.59,0-1.43-.1-3.43-.17-5.91-.1-5.09-.24-12.18-.41-20.35l.25.24h-5.75l.26-.26c0,1.54.08,3.17.13,4.83.19,7.78.37,15,.52,21.11v.18l-.17,0a10.41,10.41,0,0,0-5.93,3.82,14,14,0,0,0-2.37,5,22.06,22.06,0,0,0-.61,3.55c0,.41-.05.73-.06.94s0,.33,0,.33a1.39,1.39,0,0,1,0-.33c0-.21,0-.53,0-.95a18.6,18.6,0,0,1,.5-3.6,14,14,0,0,1,2.33-5.16,10.78,10.78,0,0,1,6.11-4l-.17.22c-.17-6.07-.38-13.32-.6-21.11-.05-1.65-.09-3.28-.13-4.83v-.27h6.27v.25c.09,8.18.17,15.26.23,20.36,0,2.48,0,4.48,0,5.91,0,.66,0,1.18,0,1.58A2.15,2.15,0,0,1,405.87,197.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,168.78s-5.84-13.66-19.75-20.41a83.17,83.17,0,0,0-16.67-6.18s8.12-1.92,21.25,3.92c6,2.66,12,6.11,16,11.3,2.52,3.29,5.68,9.72,5.67,11.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,334.25s.08-.1.25-.27.43-.43.75-.78a37.11,37.11,0,0,0,2.7-3.2,52.26,52.26,0,0,0,3.65-5.6c1.3-2.27,2.66-4.95,4.13-7.94,2.95-6,6.36-13.22,9.9-21.52,1.76-4.15,3.56-8.56,5.36-13.21l1.34-3.52a20.44,20.44,0,0,1,1.61-3.55,7.34,7.34,0,0,1,2.9-2.76,4.12,4.12,0,0,1,2-.51,2.07,2.07,0,0,1,1.06.38,2.27,2.27,0,0,1,.67.9l0,.07,0,.08a3.46,3.46,0,0,1-.54,1.33,2.1,2.1,0,0,1-1.25.82,4.53,4.53,0,0,1-2.79-.51,4.42,4.42,0,0,1-2.47-4.85,3.89,3.89,0,0,1,1.63-2.44,4.54,4.54,0,0,1,2.84-.81,3.13,3.13,0,0,1,2.62,1.45,1.51,1.51,0,0,1-.1,1.63,2.88,2.88,0,0,1-1.27.92,4.17,4.17,0,0,1-4.79-1.36,3.51,3.51,0,0,1-.65-2.52,4.33,4.33,0,0,1,1-2.36,3.62,3.62,0,0,1,2.25-1.24,2.88,2.88,0,0,1,2.43.84,1.8,1.8,0,0,1,.48,1.27,1.68,1.68,0,0,1-.58,1.23,2.8,2.8,0,0,1-2.44.66,3.07,3.07,0,0,1-1.95-1.56,6.43,6.43,0,0,1-.73-2.31,8.18,8.18,0,0,1,.53-4.66,3.47,3.47,0,0,1,1.71-1.69,3.13,3.13,0,0,1,2.37.08,2.25,2.25,0,0,1,1.47,1.85,2.06,2.06,0,0,1-1.27,2,2.52,2.52,0,0,1-2.3,0,3.18,3.18,0,0,1-1.43-1.76,4.39,4.39,0,0,1-.13-2.18,9.92,9.92,0,0,1,.46-2.08,3.81,3.81,0,0,1,1.21-1.77,4.85,4.85,0,0,1,1.89-.93,2,2,0,0,1,1.1,0,2.33,2.33,0,0,1,.91.58,2.62,2.62,0,0,1,.59.88,1.47,1.47,0,0,1,0,1.11,1.8,1.8,0,0,1-1.79,1,3.26,3.26,0,0,1-1.88-.63,5.16,5.16,0,0,1-2-3.15A5.31,5.31,0,0,1,395,248a4.05,4.05,0,0,1,1.13-1.37,3.65,3.65,0,0,1,1.59-.69,2.57,2.57,0,0,1,1.7.24,1.77,1.77,0,0,1,.92,1.41,2.49,2.49,0,0,1-1.88,2.4,2.72,2.72,0,0,1-2.72-1,4.36,4.36,0,0,1-1-2.56,16,16,0,0,1,1-4.78c.41-1.44.78-2.76,1.12-3.94.67-2.35,1.19-4.18,1.56-5.44.17-.61.31-1.08.41-1.41s.16-.48.16-.48,0,.17-.11.49-.21.82-.36,1.43c-.34,1.27-.84,3.11-1.47,5.46l-1.07,3.95c-.34,1.45-1,3-.93,4.7a4.16,4.16,0,0,0,1,2.38,2.43,2.43,0,0,0,2.4.9,2.16,2.16,0,0,0,1.62-2,1.43,1.43,0,0,0-.74-1.13,2.27,2.27,0,0,0-1.46-.19,3.27,3.27,0,0,0-1.44.63,3.76,3.76,0,0,0-1,1.25,5,5,0,0,0-.37,3.3,4.78,4.78,0,0,0,1.86,2.89,2.93,2.93,0,0,0,1.64.55,1.37,1.37,0,0,0,1.38-.73,1.53,1.53,0,0,0-.53-1.52,2,2,0,0,0-.73-.47,1.72,1.72,0,0,0-.87,0,3.8,3.8,0,0,0-2.77,2.43,9.09,9.09,0,0,0-.43,2,3.89,3.89,0,0,0,.12,2,2.63,2.63,0,0,0,1.2,1.49,2.09,2.09,0,0,0,1.87,0,1.57,1.57,0,0,0,1-1.49,1.77,1.77,0,0,0-1.17-1.43,2.72,2.72,0,0,0-2-.07,3,3,0,0,0-1.45,1.45,7.77,7.77,0,0,0-.47,4.37,6,6,0,0,0,.67,2.13,2.58,2.58,0,0,0,1.61,1.31,2.28,2.28,0,0,0,2-.53,1.24,1.24,0,0,0,.07-1.79,2.39,2.39,0,0,0-2-.67,3.07,3.07,0,0,0-1.92,1.08,3.44,3.44,0,0,0-.36,4.23,3.67,3.67,0,0,0,4.18,1.18,2.49,2.49,0,0,0,1-.75,1,1,0,0,0,.06-1.08,2.63,2.63,0,0,0-2.19-1.17,3.75,3.75,0,0,0-3.93,2.83A3.86,3.86,0,0,0,395,274a3.93,3.93,0,0,0,2.45.48,2,2,0,0,0,1.4-1.75l0,.15a1.5,1.5,0,0,0-1.31-1,3.57,3.57,0,0,0-1.77.46,6.8,6.8,0,0,0-2.71,2.58,19.53,19.53,0,0,0-1.57,3.45l-1.36,3.53c-1.8,4.64-3.62,9-5.4,13.2-3.56,8.3-7,15.54-10,21.5-1.49,3-2.87,5.65-4.2,7.92a51.29,51.29,0,0,1-3.73,5.57A26.29,26.29,0,0,1,363,334.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.09,185a13.12,13.12,0,0,0-.91-3.7,14.57,14.57,0,0,0-7.18-7.19,19.39,19.39,0,0,0-6.92-1.69,32.56,32.56,0,0,0-8.21.62c-5.73,1.06-11.75,3.53-18.49,4.55a37.7,37.7,0,0,1-9.9,0,39.84,39.84,0,0,1-8.9-2.42,39.28,39.28,0,0,1-13-8.56,35,35,0,0,1-6.28-8.4,11.9,11.9,0,0,1-.74-1.47l-.48-1.11c-.12-.27-.21-.5-.29-.68a.86.86,0,0,1-.08-.24,1,1,0,0,1,.13.22l.33.66.53,1.08a12.54,12.54,0,0,0,.78,1.45,36.41,36.41,0,0,0,6.36,8.23,39,39,0,0,0,21.67,10.73,37.07,37.07,0,0,0,9.76,0c6.65-1,12.68-3.46,18.48-4.5a32.76,32.76,0,0,1,8.32-.58,19.45,19.45,0,0,1,7.05,1.79,14.59,14.59,0,0,1,7.21,7.44,10.91,10.91,0,0,1,.69,2.78l0,.74A.86.86,0,0,1,411.09,185Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,163.45a4.87,4.87,0,0,1-.72.12c-.47.07-1.17.17-2.06.33-1.78.29-4.33.86-7.47,1.64a79.48,79.48,0,0,1-11.19,2.17,56.23,56.23,0,0,1-13.94-.31,59,59,0,0,1-13.47-3.62A57,57,0,0,1,337,158.53c-1.34-.91-2.54-1.75-3.56-2.55s-1.88-1.49-2.54-2.11l-1.52-1.43c-.34-.33-.52-.51-.5-.53a3.91,3.91,0,0,1,.57.45l1.58,1.35c.68.6,1.59,1.24,2.59,2s2.24,1.59,3.58,2.47a60.33,60.33,0,0,0,23.46,8.67,57.39,57.39,0,0,0,13.83.34,81.69,81.69,0,0,0,11.14-2c3.15-.73,5.73-1.25,7.53-1.49.9-.12,1.6-.19,2.08-.22A3.68,3.68,0,0,1,396,163.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,230.45a1.91,1.91,0,0,1-.39-.12,6.36,6.36,0,0,1-1-.53,9.18,9.18,0,0,1-2.93-3.12,15.07,15.07,0,0,1-1.8-6.09,43.67,43.67,0,0,1,0-7.76,47.28,47.28,0,0,1,1.28-7.65,22.07,22.07,0,0,1,2.23-5.93,9.16,9.16,0,0,1,3-3.11,5.48,5.48,0,0,1,1-.52c.25-.09.39-.13.39-.11s-.51.23-1.32.8a9.59,9.59,0,0,0-2.74,3.12,22.5,22.5,0,0,0-2.08,5.87,50,50,0,0,0-1.24,7.58,46.75,46.75,0,0,0,0,7.66,15.21,15.21,0,0,0,1.64,6,9.36,9.36,0,0,0,2.72,3.14C397,230.21,397.51,230.4,397.48,230.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.89,
    y: 228.29,
    width: 16.16,
    height: 6.09,
    rx: 2.85,
    transform: "translate(-38.04 71.34) rotate(-11.1)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.47,228.88,401.92,214a2.24,2.24,0,0,1,2.8,1.45h0a2.25,2.25,0,0,1-1.55,2.85l-48.52,13.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.54,222.34a10.62,10.62,0,0,1,1.57-.55l4.34-1.32c1.82-.56,4.06-1.16,6.42-1.93a4.3,4.3,0,0,0,1.55-1,2.34,2.34,0,0,0,.67-1.65,1.44,1.44,0,0,0-1-1.36,3.63,3.63,0,0,0-2,.06l-14.23,4.58-4.33,1.34A9.91,9.91,0,0,1,381,221a10.71,10.71,0,0,1,1.55-.61l4.28-1.5c3.63-1.23,8.61-2.94,14.21-4.73a4.1,4.1,0,0,1,2.28,0,2,2,0,0,1,1.32,1.84,2.84,2.84,0,0,1-.82,2A4.8,4.8,0,0,1,402,219c-2.45.77-4.64,1.31-6.49,1.83L391.17,222A8.87,8.87,0,0,1,389.54,222.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,186c1.62,5.7-4.17,10.59-6.21,16.16-2,5.38-.3,11.41,2.13,16.61s5.63,10.12,6.87,15.71c3.07,13.8-9.41,28.67-7,42.6.86,5.08,2.91,10.38,4.68,15.21a20.1,20.1,0,0,1,0,14.13c-2.7,8-7.28,11.75-10.5,19.53-1.65,4-1.52,8.44-1.44,12.74s.06,8.8-1.86,12.66-6.3,6.84-10.46,5.72a15.33,15.33,0,0,0,18.32,3.49c5.47-2.92,8.53-8.84,11.15-14.46,12.68-27.21,19.39-29.51,19-59.53,0-1.93-.38-32-.38-32a30,30,0,0,1-7.49-3.15c-14.16-9.78-14.68-27.2-14.57-40.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.3,277.08v11.33s-8.71,44.45-11.33,69.14-3.05,31.21-3.05,31.21,6.25,9.75,19.32-6.81,15.4-19.17,20.63-19.46c0,0-6.39-69.43-6.1-72a10.49,10.49,0,0,1,2.32-4.94Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.44,251.52S343.21,270.4,342.05,273s-1.75,4.06-1.75,4.06l21.79,8.43,21.21-23.24,7.84-20.63-2.33-24.4s-4.64-.29-5.51,3.78a30.57,30.57,0,0,0-.59,7.84l-6.5-5.23-10.49-3.19s-2.47,4.06,1.6,6.1,5.23,2,5.23,2l3.66,6.39-1.6,7.16-7.42-7a4.23,4.23,0,0,0-5.4-.34l-4.8,3.48-4.49-2L343.79,244l-3.49,3.19s2.33,4.36,7,2.33l4.65-2Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.3,280.91a4.71,4.71,0,0,1,0-.61c0-.4.05-1,.14-1.77a20.82,20.82,0,0,1,.55-2.85,12.64,12.64,0,0,1,1.52-3.66c3.26-5,8.39-12,14.79-20.61l0,.26-5.52-4.06.19,0-2.87,1.27a19.86,19.86,0,0,1-3.06,1.19,5,5,0,0,1-3.4-.39,6.26,6.26,0,0,1-2.56-2.44l-.08-.14.13-.12c3.74-3.52,7.91-7.07,12.19-10.87l.13-.11.14.08,3.87,2.29h-.25l4.52-3c.79-.51,1.5-1,2.35-1.52a2.82,2.82,0,0,1,2.92.25l8.81,7.45-.41.14c.48-2.15,1-4.48,1.52-6.83l0,.18-3.66-6.39.23.13a7.29,7.29,0,0,1-1.81-.49c-.57-.21-1.14-.45-1.71-.7s-1.13-.53-1.69-.8c-.29-.14-.57-.33-.85-.49a5.29,5.29,0,0,1-.76-.66,3.68,3.68,0,0,1-1-2.67,5.89,5.89,0,0,1,.77-2.72l.1-.17.2.06,10.48,3.2h.05l0,0,6.5,5.23-.41.22a31.06,31.06,0,0,1,.55-7.73,4.71,4.71,0,0,1,2.12-3.22,6.74,6.74,0,0,1,3.7-.93H389l0,.22c.82,8.67,1.59,16.85,2.3,24.4v0l0,.05c-2.9,7.6-5.54,14.5-7.88,20.61v0l0,0L367,280.31l-4.46,4.83c-.51.53-.9.95-1.17,1.24l-.41.41s.12-.16.37-.45l1.13-1.27,4.4-4.89,16.34-18,0,.05,7.8-20.64v.1c-.73-7.55-1.51-15.72-2.35-24.4l.23.23a6.16,6.16,0,0,0-3.4.86,4.18,4.18,0,0,0-1.89,2.9,30,30,0,0,0-.54,7.59l0,.58-.45-.36L376,223.83l.09,0-10.48-3.19.29-.12a5.45,5.45,0,0,0-.69,2.46,3.17,3.17,0,0,0,.86,2.31,5.37,5.37,0,0,0,.67.58c.27.15.51.31.79.45.56.27,1.11.55,1.67.79a14.69,14.69,0,0,0,3.31,1.15l.16,0,.06.1,3.66,6.39.05.09,0,.1c-.53,2.35-1,4.68-1.53,6.83l-.09.42-.33-.28-8.78-7.43a2.31,2.31,0,0,0-2.4-.22c-.74.44-1.54,1-2.3,1.49l-4.53,3-.12.08-.13-.07-3.87-2.3.28,0c-4.28,3.78-8.46,7.33-12.21,10.83l.05-.26a5.77,5.77,0,0,0,2.36,2.26,4.51,4.51,0,0,0,3.12.36,19.8,19.8,0,0,0,3-1.15l2.87-1.26.11,0,.09.06,5.51,4.08.15.11-.11.15c-6.43,8.61-11.61,15.55-14.91,20.5a13,13,0,0,0-1.55,3.59,23.18,23.18,0,0,0-.59,2.82c-.11.77-.16,1.37-.19,1.76S340.3,280.91,340.3,280.91Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.26,255.89c-.1,0,.28-1.54.44-4a9.18,9.18,0,0,0-.68-4.2,11.23,11.23,0,0,0-3.47-3.9,86.21,86.21,0,0,0-8.07-5.49l-2.55-1.5a4.9,4.9,0,0,1-.92-.59,3.6,3.6,0,0,1,1,.41c.64.29,1.55.75,2.65,1.36a66.86,66.86,0,0,1,8.2,5.4,11.23,11.23,0,0,1,3.58,4.11,9,9,0,0,1,.62,4.42,18.81,18.81,0,0,1-.49,2.94A3.89,3.89,0,0,1,367.26,255.89Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.51,246.83a19.52,19.52,0,0,1,.37-2.62,41,41,0,0,0,.45-6.3,41.84,41.84,0,0,0-.56-6.31,20.32,20.32,0,0,1-.41-2.6,10,10,0,0,1,.77,2.53,30.89,30.89,0,0,1,.11,12.75A10,10,0,0,1,382.51,246.83Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.4,172.73,275,154.36a49.21,49.21,0,1,0-11.79,13.12l0,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.4,172.73l-22.26-5.1-.19,0,.12-.16,0,0,.18.18a50.12,50.12,0,0,1-10.11,6.09,49.13,49.13,0,0,1-13.47,3.84,44.15,44.15,0,0,1-7.78.39c-1.33-.07-2.7-.11-4.07-.22l-4.15-.63A49.52,49.52,0,0,1,193,157.34a48.89,48.89,0,0,1-8.3-19,50,50,0,0,1,.58-21.85,48.42,48.42,0,0,1,10.53-20.2l2-2.21c.66-.74,1.45-1.35,2.16-2a29.35,29.35,0,0,1,2.23-2l2.36-1.76A21,21,0,0,1,207,86.76l2.49-1.51L212.1,84a21.28,21.28,0,0,1,2.63-1.17,50.25,50.25,0,0,1,22-3.39,48.55,48.55,0,0,1,20.2,6,49.78,49.78,0,0,1,23.32,28.69,52.93,52.93,0,0,1,2.14,16,48.6,48.6,0,0,1-2.4,13.79,49.58,49.58,0,0,1-4.93,10.58v-.13l10.31,18.43c-.44-.77-3.78-6.56-10.53-18.31l0-.06,0-.06a49.89,49.89,0,0,0,4.85-10.54,48.92,48.92,0,0,0,2.33-13.71,52.72,52.72,0,0,0-2.17-15.85,49.42,49.42,0,0,0-23.16-28.39,48.15,48.15,0,0,0-20-5.89,49.68,49.68,0,0,0-21.79,3.37,20.81,20.81,0,0,0-2.6,1.16l-2.58,1.25-2.47,1.5a18.31,18.31,0,0,0-2.41,1.6l-2.34,1.74c-.79.56-1.46,1.29-2.2,1.92s-1.48,1.28-2.14,2l-2,2.18a48,48,0,0,0-10.42,20,49.64,49.64,0,0,0-.59,21.63,48.51,48.51,0,0,0,8.2,18.79,49.28,49.28,0,0,0,30.38,19.59l4.11.63c1.36.12,2.72.15,4,.23a44.48,44.48,0,0,0,7.72-.36,48.87,48.87,0,0,0,23.47-9.78l.78-.6-.6.79v0l-.08-.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.47,128.63a4,4,0,1,1-4-4A4,4,0,0,1,222.47,128.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.43,128.63a4,4,0,1,1-4-4A4,4,0,0,1,238.43,128.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.36,126.63a4,4,0,1,1-5.45-1.46A4,4,0,0,1,254.36,126.63Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482,442.14c0,.15-101.66.26-227,.26s-227-.11-227-.26,101.63-.26,227.05-.26S482,442,482,442.14Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.55,442.39a26.84,26.84,0,0,1,21.39-12.08c14.61-.5,21.91,12.08,21.91,12.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.55,442a16.23,16.23,0,0,1-.43-2.18,14.09,14.09,0,0,0-5.79-8.52,18.5,18.5,0,0,1-1.87-1.2,5.22,5.22,0,0,1,2.11.82,12.39,12.39,0,0,1,6,8.82A5.27,5.27,0,0,1,381.55,442Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.51,441.86v-.1a5.6,5.6,0,0,0-5.61-5.51H214.56a5.61,5.61,0,0,0-5.61,5.61H344.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.47,224c0,2.62,2,158.78,2,158.78l116,27.91H234l-6.1-218h-8.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,376.29,95.05,442.17h32.86c-5.88-.58,52,0,52,0l-52-13.79,16.27-36.95-1.39-15.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.8 388.45 127.91 265.65 163.23 262.27 167.58 393.38 154.97 394.02 131.8 388.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.52,398.24s0-.19,0-.57,0-.95,0-1.68c0-1.5,0-3.69,0-6.52,0-5.71-.05-14-.08-24.43,0-20.87-.05-50.24-.09-84.3l.25.25H130.85l.26-.26v5.66c0,33.22,0,64.13-.05,89.89v0l0,.05c-10.82,19.83-19.79,36.29-26.07,47.79-3.14,5.74-5.61,10.24-7.3,13.32-.84,1.52-1.49,2.68-1.93,3.49s-.69,1.18-.69,1.18.21-.42.63-1.21,1.06-2,1.87-3.53c1.67-3.09,4.1-7.61,7.2-13.37l25.9-47.88,0,.11c0-25.76,0-56.67,0-89.89v-5.92h42.18v.25c0,34.06-.07,63.43-.09,84.3,0,10.42-.06,18.72-.08,24.43,0,2.83,0,5,0,6.52,0,.73,0,1.29,0,1.68S172.52,398.24,172.52,398.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.18,391.43c.13.05-4.87,11.62-11.17,25.82s-11.52,25.68-11.65,25.62,4.87-11.62,11.17-25.83S144.05,391.37,144.18,391.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.42,410.73s0-.19,0-.56,0-.94,0-1.65c0-1.47-.05-3.6-.08-6.34,0-5.5-.17-13.46-.36-23.3-.37-19.68-1.26-46.85-2.35-76.86s-1.92-57.21-2.2-76.89c-.15-9.84-.22-17.81-.19-23.31,0-2.74,0-4.87,0-6.34,0-.71,0-1.25,0-1.65s0-.56,0-.56,0,.19,0,.56,0,.94,0,1.65c0,1.47,0,3.6.08,6.34,0,5.5.16,13.46.36,23.3C220.11,244.8,221,272,222.09,302s1.92,57.19,2.2,76.87c.15,9.84.21,17.81.19,23.31,0,2.74,0,4.87,0,6.34,0,.71,0,1.26,0,1.65S224.42,410.73,224.42,410.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.19,279.83c.15,0,.26,26.12.26,58.33s-.11,58.33-.26,58.33-.26-26.11-.26-58.33S166.05,279.83,166.19,279.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.7,431.89a4.39,4.39,0,0,1-.5-.7c-.17-.24-.36-.53-.58-.86a11.61,11.61,0,0,1-.72-1.22,30.77,30.77,0,0,1-3.17-8.45,41.86,41.86,0,0,1-.62-13.37,53.5,53.5,0,0,1,4.34-15.81,32.83,32.83,0,0,1,4.53-7.21,18.21,18.21,0,0,1,1.33-1.56c.46-.5.9-1,1.36-1.48,1-.91,1.87-1.84,2.86-2.63a46.1,46.1,0,0,1,5.81-4.21c1-.54,1.91-1.11,2.85-1.56s1.83-.93,2.73-1.25a31.28,31.28,0,0,1,8.72-2.32,16.47,16.47,0,0,1,2.45-.15,5.16,5.16,0,0,1,.86,0,6.66,6.66,0,0,1-.85.09,21.58,21.58,0,0,0-2.43.25,32.77,32.77,0,0,0-8.61,2.46c-.89.33-1.75.83-2.69,1.26s-1.84,1-2.81,1.58a46.15,46.15,0,0,0-5.72,4.21c-1,.78-1.87,1.71-2.82,2.61-.45.47-.89,1-1.34,1.46a19.38,19.38,0,0,0-1.3,1.55,32.5,32.5,0,0,0-4.46,7.11,53.61,53.61,0,0,0-4.33,15.64,42.24,42.24,0,0,0,.5,13.24,32.32,32.32,0,0,0,3,8.43,10.64,10.64,0,0,0,.68,1.24l.53.89A6.44,6.44,0,0,1,103.7,431.89Z",
    style: {
      fill: "#455a64"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactusPana);
export default __webpack_public_path__ + "static/media/Contact us-pana.41fe4bf762374d05a74838864bb2aeb5.svg";
export { ForwardRef as ReactComponent };